var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eden-empty--page"},[_c('el-empty',{attrs:{"image":_vm.getImage('empty-page.svg'),"description":'Currently building...',"image-size":200}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }